import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutModule } from '@angular/cdk/layout';
import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';
import { AuthRedirectComponent } from './auth-redirect.component';

@NgModule({
	declarations: [
    AuthRedirectComponent
  ],
	imports: [
		CommonModule,
		RouterModule,
		LayoutModule,
		ReactiveFormsModule,
        AngularMaterialModule,
		SharedModule
	]
})
export class AuthModule {
}